module.exports = __webpack_public_path__ + "img/v2-redesign-library-filter.2c30d306.png";